<template>
  <v-dialog
      :id="`dialog_add_category`"
      v-model="show"
      max-width="620px"
      @click:outside="cancel"
      @keydown.esc="cancel"
  >
    <v-card>
      <v-card-title class="justify-center">
        <span v-html="title"></span>
      </v-card-title>
      <v-card-text class="justify-center">
        <v-container>
          <v-select
              ref="label_selector"
              :label="$t('parameters.label.labelName')"
              :items="extendedLabelsListForSelect"
              item-text="label"
              item-value="name"
              v-model="categoryLabel"
              single-line
          ></v-select>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
            text
            @click="cancel"
        >
          {{ this.$t("app.button.cancel") }}
        </v-btn>
        <v-btn
            :disabled="!categoryLabel"
            color="primary"
            @click="addCategoryOnCurrentList"
        >
          {{ this.$t("app.button.apply") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapState, mapGetters, mapActions} from "vuex";

export default {
  name: "addCategoryDialog",
  props: ["show", "title", "currentDoc"],
  data() {
    return {
      categoryLabel: null,
    }
  },
  computed: {
    ...mapState("document", ["searchParams"]),
    ...mapGetters("settings", ["extendedLabelsListForSelect"]),
  },
  methods: {
    ...mapActions("document", ["searchAndCategorizeDocuments"]),
    cancel() {
      this.$emit("cancel");
    },
    done() {
      this.$emit("done");
    },
    addCategoryOnCurrentList() {
      this.$refs["label_selector"].blur();
      this.done();
      // https://stackoverflow.com/questions/63896901/problem-with-updating-model-in-vuetify-combobox
      this.$nextTick(async () => {
        const category = {add: true, labelName: this.categoryLabel};
        await this.searchAndCategorizeDocuments({
          params: this.searchParams,
          category: category,
        });
      })
    },
  }
}
</script>
